import React, { useEffect, useRef, useState } from "react";
import Searchbar from "../../../Components/Searchbar/Searchbar";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import UserTable from "../../../Components/Table/UserTable";
import { GetUser } from "../../../APIs/Function/User/GetUser";
import { SearchDebouncing } from "../../../APIs/Search/SearchDebouncing";
import throttle from "lodash.throttle";import debounce from "lodash.debounce"; 
const Users = () => {
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [page, setPage] = useState(0);
  const [lastpage, setLastPage] = useState("");
  const containerRef = useRef(null);
  const [usertype, setUsertype] = useState("");
  const handleUser = async () => {
    try {
      // setLoading(true);
      let res = await GetUser(page, usertype);
      if (usertype) {
        setUserData(res.r);
      }else{
        setUserData((prevData) => [...prevData, ...res.r]);
      }
      setLastPage(res.c);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleScroll = () => {
    console.log('scrolled')
    if (
      containerRef.current &&
      containerRef.current.scrollTop + containerRef.current.clientHeight >=
        containerRef.current.scrollHeight - 1
    ) {
      setPage((prevPage) => prevPage + 15); // Increment the page by 1
    }
  };
  console.log("p", page);
  const handleSearch = async (e) => {
    const searchValue = e.target.value.trim();
    if (searchValue?.length === 0) {
      setSearchData([]);
      setSearched(false);
      return;
    }
    try {
      await SearchDebouncing(1, searchValue, setSearchData);
      setSearched(true);
    } catch (error) {
      console.log(error);
    }
    setPage(0);
  };

  useEffect(() => {
    handleUser(page, usertype);
  }, [page, usertype]);

  const throttledHandleScroll = useRef(throttle(handleScroll, 200)); 

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.addEventListener("scroll", throttledHandleScroll.current);
    }
    return () => {
      if (containerRef.current) {
        containerRef.current.removeEventListener("scroll", throttledHandleScroll.current);
      }
    };
  }, []);

  const handleChangeUser = (e) => {
    setUsertype(e.target.value);
  };
  return (
    <>
      <Box sx={{ p: 2, boxSizing: "border-box" }}>
        <Box display={"flex"} gap={1}>
          <Searchbar placeholder={"Search User"} onChange={handleSearch} />
          <FormControl sx={{ width: "25%" }}>
            <InputLabel sx={{ bgcolor: "#FFF" }}>
              Filter By User type
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={usertype}
              label="User Type"
              onChange={(e) => handleChangeUser(e)}
            >
              <MenuItem disabled value={""}>
                Filter By User type
              </MenuItem>
              <MenuItem value={1}>Basic</MenuItem>
              <MenuItem value={2}>Premium</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box
          ref={containerRef}
          style={{
            overflowY: "auto",
            maxHeight: "610px",
            p: 1,
            boxSizing: "border-box",
          }}
          onScroll={handleScroll}
        >
          {searched && searchData?.length > 0 ? (
            <UserTable
              setUserData={setUserData}
              userData={searchData}
              loading={loading}
            />
          ) : !searched ? (
            <UserTable
              setUserData={setUserData}
              userData={userData}
              loading={loading}
            />
          ) : (
            ""
          )}
        </Box>
      </Box>
    </>
  );
};

export default Users;
